import React from 'react';
import PropTypes from 'prop-types';
import './empty-state.m.css';

const EmptyState = ({
  width = '100px',
  height = '100px',
  titleMessage = 'No Data Available',
  subTextMessage = 'at the moment'
}) => {
  return (
    <div styleName="empty-state-container">
      <img src="/images/lighthouse.svg" alt="lighthouse" width={width} height={height} loading="lazy" />
      <span styleName="title-message">{titleMessage}</span>
      <span styleName="sub-text">{subTextMessage}</span>
    </div>
  );
};

EmptyState.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  titleMessage: PropTypes.string,
  subTextMessage: PropTypes.string
};

export default EmptyState;
